import * as Yup from "yup";
import moment from "moment";
import { pregnancyValidationFn } from "../Components/pregnancyValidationSchema";

export function createHouseholdMemberValidationSchema(isResponsiblePartyDifferent) {
    return Yup.object().shape({
        firstName: Yup.string()
            .nullable()
            .required("Required"),
        lastName: Yup.string()
            .nullable()
            .required("Required"),
        dateOfBirth: Yup.date()
            .min(
                moment()
                    .subtract(120, "years")
                    .format(),
                `Max 120 years`
            )
            .max(new Date(), `Invalid`)
            .required("Required")
            .typeError("Invalid"),
        gender: Yup.string()
            .nullable()
            .required("Required"),
        pregnancy: pregnancyValidationFn("gender", "dateOfBirth"),
        relationshipToPatient: Yup.string("Required")
            .nullable()
            .required("Required"),
        livesWithPatient: Yup.bool()
            .nullable()
            .required("Required"),
        relationshipToResponsibleParty: isResponsiblePartyDifferent
            ? Yup.string()
                  .nullable()
                  .required("Required")
            : Yup.mixed(),
        livesWithResponsibleParty: isResponsiblePartyDifferent
            ? Yup.bool()
                  .nullable()
                  .required("Required")
            : Yup.mixed(),        
    });
}
